module.exports = __webpack_public_path__ + "img/k.0bf58325.jpg";